import PropTypes from "prop-types";
import { toast } from "sonner";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import { useEmailExemptionsMutations } from "hooks/useEmailExemptionsTable";

// The Semantic ConfirmationModal mounts inside its own trigger, so it unmounts
// with the shadcn row menu; this controlled dialog lives outside the menu.
const DeleteEmailExemptionModal = ({ exemptionId, open, onOpenChange }) => {
  const { remove } = useEmailExemptionsMutations();

  const handleDelete = async () => {
    try {
      await remove.mutateAsync(exemptionId);
      toast.success("Email exemption deleted");
      onOpenChange(false);
    } catch {
      toast.error("Failed to delete email exemption");
    }
  };

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Delete email exemption?"
      description="Are you sure you want to delete this Email Exemption?"
      onConfirm={handleDelete}
    />
  );
};

DeleteEmailExemptionModal.propTypes = {
  exemptionId: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func.isRequired,
};

export default DeleteEmailExemptionModal;
